<div class="rod-modal-content" [ngClass]="customContentClass" (click)="closeByBackdrop($event)">
	<div class="rod-modal" [ngClass]="customClass">
		@if (showCloseButton) {
			<div class="close-button" (click)="closeModal()">
				<img src="/assets/icons/svg/close-modal.svg" alt="Fechar modal" loading="lazy" />
			</div>
		}
		@if (title !== '') {
			<div class="title">
				{{ title }}
			</div>
		}
		<div class="content">
			<ng-content></ng-content>
		</div>
	</div>
	<!-- <div class="backdrop" ></div> -->
</div>
